"use client";

import Image from "next/image";
import Link from "next/link";

export function TopNavLogo() {
	return (
		<Link href="/" className="group flex items-center justify-center">
			<div className="h-8 w-8 overflow-hidden rounded-md ring-offset-background transition-all duration-200 group-hover:ring-4 group-hover:ring-primary/10 group-active:scale-95 group-active:ring-primary/20">
				<Image
					src="/images/logos/humble-logo-brand.png"
					alt="Humble Logo"
					width={32}
					height={32}
					className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-105 group-active:scale-100 [color-scheme:only_light]"
					priority
					fetchPriority="high"
				/>
			</div>
		</Link>
	);
}
